import {
  DRAWER_TOGGLE
} from '../types/drawer'

export const drawerToggle = () => ({
  type: DRAWER_TOGGLE
});
